import React from "react";
import { Stage } from "react-konva";
import { HorizontalRuler, VerticalRuler, RULER_SIZE } from "./Rulers";
import { useEditorCanvasLogic } from "./useEditorCanvasLogic"; // Import hooka
import EditorCanvasRenderer from "./EditorCanvasRenderer"; // Import komponentu renderującego

export default function EditorCanvas({
  pages,
  currentPage,
  zoomFactor,
  selectedShapeId,
  setSelectedShapeId,
  editingTextId,
  setEditingTextId,
  handleChangeText,
  handleChangeImage,
  handleChangeSvg,
  assetsAreLoaded, // Nadal potrzebne? Może w overlay? Na razie zostawiam.
  assetsTotal, // Nadal potrzebne? Może w overlay? Na razie zostawiam.
  assetsCount, // Nadal potrzebne? Może w overlay? Na razie zostawiam.
  forceRefresh,
  publicMode,
  onImageDropped, // Nadal potrzebne? Obsługiwane globalnie? Na razie zostawiam.
  onRebusDrop, // Nadal potrzebne? Obsługiwane globalnie? Na razie zostawiam.
  fakeDraggingRebus, // Nadal potrzebne? Obsługiwane globalnie? Na razie zostawiam.
  setFakeDraggingRebus, // Nadal potrzebne? Obsługiwane globalnie? Na razie zostawiam.
  guides,
  fontsAreLoaded,
  onAutoSnapChangePages, // Nadal potrzebne? Może w overlay? Na razie zostawiam.
  onCanvasInsideChange,
  onCanvasPosChange,
  stageRef, // Przekazujemy ref do hooka
  isProjectPersonalized, // Dodajemy nowy prop
  // Dodajemy propsy baseWidth i baseHeight, które przyszły z Editor.js
  baseWidth: passedBaseWidth,
  baseHeight: passedBaseHeight,
  backendUrl, // Dodajemy backendUrl
  foldLineConfig // Dodajemy foldLineConfig
}) {

  // Użycie hooka do zarządzania logiką
  const {
    layerRef,
    transformerRef,
    // insideCanvas, // Nie jest już bezpośrednio używany w tym komponencie
    // lastPointerPosRef, // Nie jest już bezpośrednio używany w tym komponencie
    tempGuides,
    validPage,
    baseWidth,
    baseHeight,
    stageWidth,
    stageHeight,
    stageOffsetX,
    stageOffsetY,
    containerWidth,
    containerHeight,
    // findObjById, // Używany w rendererze
    handleObjectDragMove,
    handleDragEnd,
    handleStageMouseDown,
    handleMouseEnterCanvas,
    handleMouseLeaveCanvas,
    handleMouseMoveCanvas,
    handleDragOver,
    handleDrop,
    handleMouseUpCanvas,
    isDragging // Pobieramy nowy stan z hooka
  } = useEditorCanvasLogic({
    pages,
    currentPage,
    zoomFactor,
    selectedShapeId,
    setSelectedShapeId,
    editingTextId,
    setEditingTextId,
    handleChangeText,
    handleChangeImage,
    handleChangeSvg,
    forceRefresh,
    publicMode,
    guides,
    onCanvasInsideChange,
    onCanvasPosChange,
    stageRef, // Przekazujemy stageRef do hooka
    isProjectPersonalized, // Przekazujemy prop do hooka
    // Przekazujemy wymiary bazowe do hooka, jeśli są dostępne
    baseWidth: passedBaseWidth,
    baseHeight: passedBaseHeight
  });

  // Komunikaty o błędach lub braku stron
  if (!pages || pages.length === 0) {
    return (
      <div style={{ padding: 16, textAlign: "center", color: "#6c757d" }}>
        Brak stron do wyświetlenia.
      </div>
    );
  }
  if (!validPage) {
    console.error(`Invalid currentPage index: ${currentPage} for pages length: ${pages.length}`);
    return (
      <div style={{ padding: 16, textAlign: "center", color: "#dc3545" }}>
        Błąd: Nieprawidłowy indeks bieżącej strony.
      </div>
    );
  }

  // Renderowanie struktury komponentu z linijkami i obszarem Stage
  return (
    <div
      style={{
        position: "relative",
        width: containerWidth,
        height: containerHeight,
        margin: 0,
        backgroundColor: "transparent",
        overflow: "visible" // Pozwala linijkom być widocznym poza głównym kontenerem
      }}
    >
      {/* Linijka pozioma */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: stageOffsetX,
          width: stageWidth,
          height: RULER_SIZE
        }}
      >
        <HorizontalRuler baseWidth={baseWidth} zoomFactor={zoomFactor} />
      </div>
      {/* Linijka pionowa */}
      <div
        style={{
          position: "absolute",
          top: stageOffsetY,
          left: 0,
          width: RULER_SIZE,
          height: stageHeight
        }}
      >
        <VerticalRuler baseHeight={baseHeight} zoomFactor={zoomFactor} />
      </div>
      {/* Narożnik linijek */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: RULER_SIZE,
          height: RULER_SIZE,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 10,
          color: "#6c757d",
          borderRight: "1px solid #dee2e6",
          borderBottom: "1px solid #dee2e6",
          backgroundColor: "#f8f9fa"
        }}
      >
        mm
      </div>

      {/* Kontener dla Konva Stage */}
      <div
        style={{
          position: "absolute",
          top: stageOffsetY,
          left: stageOffsetX,
          width: stageWidth,
          height: stageHeight,
          border: "1px solid #ced4da",
          boxSizing: "content-box", // Ważne, aby border nie powiększał wymiarów
          backgroundColor: "#ffffff",
          overflow: "hidden" // Ukrywa elementy Konva wychodzące poza obszar
        }}
        // Przypisanie handlerów zdarzeń myszy i przeciągania do kontenera Stage
        onMouseEnter={handleMouseEnterCanvas}
        onMouseLeave={handleMouseLeaveCanvas}
        onMouseMove={handleMouseMoveCanvas}
        onMouseUp={handleMouseUpCanvas} // Pusty, obsługa globalna
        onDragOver={handleDragOver} // Zapobiega domyślnej akcji przeglądarki
        onDrop={handleDrop} // Zapobiega domyślnej akcji przeglądarki
      >
        <Stage
          ref={stageRef} // Używamy przekazanego refa
          width={stageWidth}
          height={stageHeight}
          scaleX={zoomFactor}
          scaleY={zoomFactor}
          onMouseDown={handleStageMouseDown} // Handler kliknięcia na Stage
        >
          {/* Użycie komponentu renderującego do wyświetlenia zawartości warstwy */}
          <EditorCanvasRenderer
            layerRef={layerRef}
            transformerRef={transformerRef}
            pages={pages}
            currentPage={currentPage}
            validPage={validPage}
            baseWidth={baseWidth}
            baseHeight={baseHeight}
            zoomFactor={zoomFactor}
            selectedShapeId={selectedShapeId}
            setSelectedShapeId={setSelectedShapeId}
            editingTextId={editingTextId}
            setEditingTextId={setEditingTextId}
            handleChangeText={handleChangeText}
            handleChangeImage={handleChangeImage}
            handleChangeSvg={handleChangeSvg}
            publicMode={publicMode}
            guides={guides}
            tempGuides={tempGuides}
            handleObjectDragMove={handleObjectDragMove}
            handleDragEnd={handleDragEnd}
            fontsAreLoaded={fontsAreLoaded}
            stageRef={stageRef} // Przekazujemy stageRef do renderera (potrzebne dla EditableText)
            isDragging={isDragging} // Przekazujemy stan isDragging do renderera
            // Przekazujemy dodatkowe propsy do renderera ze zmienionymi nazwami
            pageIsPersonalized={isProjectPersonalized}
            pageGuides={guides}
            pageBaseWidth={baseWidth}
            pageBaseHeight={baseHeight}
            backendUrl={backendUrl} // Przekazujemy backendUrl do renderera
            foldLineConfig={foldLineConfig} // Przekazujemy foldLineConfig do renderera
          />
        </Stage>
      </div>
    </div>
  );
}
